import { SxProps } from '@mui/material';
import styled from 'styled-components';
import { PageTitle } from '../../design_system/texts';
import { Flex, Text } from '../../legacy/style';

export const Title = styled(PageTitle)`
    margin: 12px 0 24px;
`;

export const tooltipCell: SxProps = {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const EmptyProject = styled(Flex).attrs({ column: true })`
    height: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const TextInformation = styled(Text).attrs({ size: '18px' })`
    line-height: 1;
`;
